import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import {
  ANIMATED_COVER_2DO_ESCALON_URL,
  SHOW_COVER_2DO_ESCALON_URL,
  resolveHeroColors,
} from '../data';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const {
    background,
    accent,
    accentRgb,
    textOnBackground,
    logoUrl,
    videoOverlayOpacity,
  } = resolveHeroColors(theme);

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        overflow: 'hidden',
        bgcolor: background,
        transition: 'background-color 0.35s ease',
      }}
    >
      <Box position="relative" zIndex={1} width="100%" py={{ xs: 6, md: 8 }}>
        <Container>
          <Box textAlign="center" sx={{ color: textOnBackground }}>
            <Box
              sx={{
                backgroundImage: logoUrl,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 72, md: 100 },
                maxWidth: 280,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Typography
              sx={{
                textTransform: 'uppercase',
                fontWeight: 600,
                letterSpacing: 1,
                color: textOnBackground,
                opacity: 0.92,
              }}
              variant="overline"
              display="block"
              gutterBottom
            >
              Propuesta comercial · Inbound Marketing
            </Typography>
            <Typography
              variant="h2"
              fontWeight={900}
              gutterBottom
              align="center"
              sx={{ color: textOnBackground }}
            >
              Prudence × TNO Network
            </Typography>
            <Typography
              variant="h6"
              component="p"
              align="center"
              sx={{ fontWeight: 500, color: textOnBackground, opacity: 0.95 }}
            >
              Placer Inteligente, Decisiones Seguras
            </Typography>
            <Box sx={{ width: '100%', maxWidth: 900, mx: 'auto', mt: 4 }}>
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  borderRadius: 2,
                  overflow: 'hidden',
                  boxShadow: `0 16px 40px ${accent}55`,
                  aspectRatio: '16 / 9',
                  bgcolor: theme.palette.background.paper,
                  border: `3px solid ${accent}`,
                }}
              >
                <Box
                  component="video"
                  src={ANIMATED_COVER_2DO_ESCALON_URL}
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster={SHOW_COVER_2DO_ESCALON_URL}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
                {videoOverlayOpacity > 0 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      zIndex: 1,
                      background: `linear-gradient(180deg, transparent 0%, rgba(${accentRgb.r}, ${accentRgb.g}, ${accentRgb.b}, ${videoOverlayOpacity}) 55%)`,
                      pointerEvents: 'none',
                    }}
                  />
                )}
              </Box>
              <Typography
                variant="body2"
                align="center"
                sx={{
                  mt: 2,
                  color: textOnBackground,
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  opacity: 0.95,
                }}
              >
                2do Escalón con Karla Aleska y Mariana · humor, cultura pop y bienestar para la juventud
              </Typography>
            </Box>

            <Typography
              variant="body1"
              align="center"
              sx={{ mt: 3, maxWidth: 640, mx: 'auto', color: textOnBackground, opacity: 0.92 }}
            >
              Educación sexual responsable con humor inteligente, bienestar y prevención — micros con Karla Aleska y
              Mariana en el ecosistema TNO Network.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
